/**
 * @flow
 * */

import styled from 'react-emotion'

import { mobile, tablet, desktop } from '../../../utils/mixins'
import Colors from '../../../themes/Colors'

import {
  SkewComponentContainer,
  SkewText
} from '../../IbcArcade/SkewComponent/styledComponents'
import CloudinaryS3Image from '../../CloudinaryS3Image'

export const ArcadeGalleryContainer = styled.div`
  position: relative;
  ${mobile} {
    font-size: 14px;
  }
  ${tablet} {
    font-size: 16px;
  }
  ${desktop} {
    font-size: 16px;
  }
`

export const GalleryImageWithLoader = styled.div`
  position: relative;
  ${mobile} {
    width: 100vw;
    object-fit: contain;
  }
`

export const GalleryImage = styled(CloudinaryS3Image)`
  max-width: 100%;
  ${mobile} {
    object-fit: cover;
    min-height: 224px;
  }
  ${tablet} {
    height: 480px;
    object-fit: cover;
  }
  ${desktop} {
    width: 100%;
    height: 100%;
  }
`

export const ThumbnailStripContainer = styled.div``

export const LoaderContainer = styled('div')`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 100%;
  min-height: 9.375em;
`

export const ArcadeNameLabelContainer = styled.div`
  width: 100%;
  position: absolute;
  z-index: 1;
`

export const GallerySkewComponentContainer = styled(SkewComponentContainer)`
  ${mobile} {
    margin-left: 0.3em;
    margin-top: 1em;
    padding-left: 0.4em;
    padding-right: 0.6em;
  }
  ${tablet} {
    margin-left: 0.3em;
    margin-top: 2.5em;
    padding-top: 0.125em;
    padding-bottom: 0.125em;
  }
  ${desktop} {
    margin-left: 6.625em;
    margin-top: 4.9375em;
    padding-top: 0.125em;
    padding-bottom: 0.075em;
  }
`

export const GallerySkewText = styled(SkewText)`
  color: ${Colors.black};
  font-weight: 400;
  ${mobile} {
    font-size: 1em;
    line-height: 1;
  }
  ${tablet} {
    font-size: 1.25em;
  }
  ${desktop} {
    font-size: 1.25em;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ArcadeGallery/styledComponents.js